import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { VisiteListDialog } from '../../actions/visite-list-dialog/visite-list-dialog.component';

import { DialogService, VisiteService,StateService,ConsultationService } from '../../../../../services';
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse';
import { take } from 'rxjs/operators';

import { VisiteActionsDialog } from '../../actions/visite-actions-dialog/visite-actions-dialog.component'
import { CreateConsultationDialogComponent } from "../../actions/create-consultation-dialog/create-consultation-dialog.component"
import { ContextMenu } from "../../../layout/context-menu/icontextmenu.component"

const KEY = 'consultation-single-page'

@Component({
	selector: 'atyl-consultation-single',
	templateUrl: './consultation-single.component.html',
	styleUrls: ['./consultation-single.component.scss'],
})
@Stringable({
	path: 'views/pages/consultation/single',
	key: KEY,
})
export class ConsultationSingleComponent implements OnInit {
	@Input() columns:number = 0;
	@Input() consultation: any = {};
	@Input() currentConsultation: any
	@Input() isvisite: boolean = false;
	@Input() isConsultation: boolean = false;
	@Input() periodvisit: any;
	
	@Output() consultationClicked = new EventEmitter<any>();
	visites: any = [];
	loading: boolean = false;
	removeClasses: boolean = false;
	active: boolean = false;
    dialogOpened: boolean = false;
	@Input() selected: boolean = false;
	@StringableValues(KEY) strings: any
    
    beginHour:number=800
    beginEnd:number=2000;
    priodTranch:number=10;
    priodAjustTranch:number=40;
    periods:any=[];
    bott: string;
    block: any = {
        startTime: null,
        endTime: null,
        color: null,
        alpha: null
    };
	
	isDisplayContextMenu: boolean;
	rightClickMenuItems: Array<ContextMenu> = [];
	rightClickMenuPositionX: number;
	rightClickMenuPositionY: number;
	rightClickMenuInset:any={};
    
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
        private dialogService: DialogService,
        private changeDetectorRef: ChangeDetectorRef,
        private visitService: VisiteService,
		private consultationService: ConsultationService,
		private stateService: StateService,
				
	) { }

	ngOnInit(): void {
		this.getInitPeriod();
        this.block = {
            startTime: this.consultation.periodes[0],
            endTime:this.consultation.periodes[this.consultation.periodes.length-1],
            color: this.consultation.consultation ?this.consultation.consultation.type.color:this.consultation.type.color,
            alpha: this.consultation.consultation ?this.consultation.consultation.alpha:this.consultation.type.alpha
        }
	}

    convertHourToDecimal(hourString: any) {
        // Convertir la chaîne en nombre entier
        let decimalHour;
        let houstringString = hourString.toString();
        if(houstringString.length == 3){
            decimalHour = houstringString[0]+"."+ houstringString[1]+ houstringString[2];
        }else if(houstringString.length == 4){
            decimalHour = houstringString[0]+houstringString[1]+"."+ houstringString[2]+ houstringString[3];
        }

        return parseFloat(decimalHour);
    }

    calculateWidth(): string {
        if(this.consultation.width){
            return this.consultation.width+"rem";
        }else{
            return "1rem";
        }
    }

    calculateLeft(): string {
        if(this.consultation.move){
            return this.consultation.move+"rem";
        }else{
            return "2rem";
        }
    }
 
    calculateHeight(startTime: string, endTime: string): string {
        let start = parseFloat(startTime);
        let end = parseFloat(endTime);
        let reelStart = this.convertHourToDecimal(start);
        let reelEnd = this.convertHourToDecimal(end).toString()[3] == '5'?this.convertHourToDecimal(end)+0.5:this.convertHourToDecimal(end)+0.1;
        if(reelEnd.toString()[2] == "6")
            reelEnd = this.convertHourToDecimal(end)+0.5;
        let pixels;
        if((reelEnd - reelStart)<= 0.1 ){
            let intervals = (reelEnd - reelStart) * 6;
            pixels = intervals * 65;
            this.bott = "0px"
        }else if((reelEnd - reelStart)> 0.1 && (reelEnd - reelStart)<=0.5 ){
            let intervals = (reelEnd - reelStart) * 6;
            pixels = intervals * 27;
            this.bott = "0px"
        }else if((reelEnd - reelStart)> 0.5 && (reelEnd - reelStart)<=1){ //changement 
            let intervals = (reelEnd - reelStart) * 6;
            if( (reelEnd-reelStart) != 0.5999999999999996){
                pixels = intervals * 17.2;
            }else{
                pixels = intervals * 11.1;
            }
            this.bott = "40px"
        }else if((reelEnd - reelStart)>1 && (reelEnd - reelStart)<=2 ){
            let intervals = (reelEnd - reelStart) * 6;
            pixels = intervals * 16.1;
            this.bott = "50px"
        }else if((reelEnd - reelStart)>2 && (reelEnd - reelStart)<=3 ){
            let intervals = (reelEnd - reelStart) * 6;
            pixels = intervals * 16;
            this.bott = "150px"
        }else if((reelEnd - reelStart)>3 && (reelEnd - reelStart)<=4 ){
            let intervals = (reelEnd - reelStart) * 6;
            pixels = intervals * 15.9;
            this.bott = "240px"
        }else if((reelEnd - reelStart)>4 && (reelEnd - reelStart)<=5 ){
            let intervals = (reelEnd - reelStart) * 6;
            pixels = intervals * 16;
            this.bott = "250px"
        }else if((reelEnd - reelStart)>5.0 && (reelEnd - reelStart)<=7 ){
            let intervals = (reelEnd - reelStart) * 6;
            pixels = intervals * 16.6;
            this.bott = "670px"
        }else if((reelEnd - reelStart)>7.0 ){
            let intervals = (reelEnd - reelStart) * 6;
            pixels = intervals * 15.8;
            this.bott = "670px"
        }
        
        //console.log("calculateHeight:",reelEnd, "-",reelStart,"=",reelEnd-reelStart,"\nend:",reelEnd);
        return pixels.toString() + "px";
    }

    calculatePosition(): string {
        return 'absolute'; 
    }
	
	getInitPeriod() {
		let count=0;
		
		let preiodConlt:any=this.consultation.periodes;
		/*console.log("periods",
		preiodConlt);*/
		let beginConsult=-1;
		while(this.beginHour<=this.beginEnd) {
			let hm =('0' + this.beginHour).slice(-4);
			let consult:boolean=false;
			for(let i:number=0;i<preiodConlt.length;i++) {
				if (consult) {
				 //beginConsult=false;
				 break;
				}
				if (!consult && preiodConlt[i]==hm ) {
				   consult=true;
				   if (beginConsult==-1)
				   	 beginConsult=1;
				  
				}
			}	
			let hmo={
				
				period: hm,
				labelTitle: ((this.beginHour % 100)==0) ? hm : "-",
				label: ((this.beginHour % 100)==0) ? "-" : ".",
				consult: consult,
				begin: (beginConsult==1)
				
			};
			
			if (this.periodvisit==undefined
				|| (this.periodvisit.period==hmo.period)
			)
            
            if(hmo.begin == true){
                this.periods.push(hmo);
            }
				
			if(beginConsult==1)
				beginConsult=0;
			
			this.beginHour+= this.priodTranch;
			count++;
			if (count==6) {
				count=0;
				this.beginHour+=this.priodAjustTranch;
				
			}
		}
		/*console.log("periods",
		this.consultation,
		this.periods);*/
	}

	showCurrentConsultationDay(event: any,type) {
       /*
		this.router.navigate([`/home/consultation/${event.ID}`], {
			relativeTo: this.activatedRoute,
		})
		*/
		if (event.action==undefined && !this.isDisplayContextMenu) {
	        this.loading=true;
	        this.visitService.getVisitesByConsultation(this.consultation.consultation? this.consultation.consultation.ID: this.consultation.ID).subscribe((visites: JSONRpcResponse,) => {
	            console.log("showCurrentConsultationDay visites:",visites);
	            if(visites){
	                this.consultation.visitesObj = visites.result;
	            }
	            this.changeDetectorRef.detectChanges();
	            
	            const visiteToOpen = type == "visite"? this.consultation.ID: null
	        
	            var data = {
	                consultation: this.consultation,
	                title: this.consultation.consultation ? this.consultation.consultation.type.libelle : this.consultation.type.libelle,
	                loading: false,
	                visiteToOpen: visiteToOpen
	            };
	
	            this.dialogService.open(VisiteListDialog, {
	                data: data,
	                height: '90vh',
	                width: "90vw",
	            });
	
	            this.loading=false;
	        })
	     }   
        
	}
	
	getStyleAppointemnt(defaultCss?:string) {
		 let css:any=[];
		 if (defaultCss!=undefined)
		 	css.push(defaultCss);
        
     	if (this.columns==1)
			css.push("day-appointment-small");
        //console.log("getStyleAppointemnt",this.columns,css)
        return css.join(" ")
		
	}
	
	getClassAppointement(period:any) {
		let css:string[]=[];
		css.push("perioddiv");//day-appointment
		if (period.begin  && period.consult)
			css.push("day-appointment-begin");
		if (period.end && period.consult)
			css.push("day-appointment-end");
		console.log("getClassAppointement",period,css);
		return 	css.join(" ");	
		
	}
	
	displayPeriod(period:any) {
        let css:any=[];
       
		
        css.push("perioddiv");
        if (period.begin)
           css.push("perioddiv-begin");
        
        return css.join(" ")
    }
    
    getStyleEvent() {
		
		let style:any={position:"absolute",
			background: this.block.color
		};
		console.log("getStyleConsultation",this.consultation,style);
	    if (this.consultation.inset!==undefined) {
			
			let inset:any=this.consultation.inset;
			let st:string=inset.top+"% "+inset.right+"% "+ inset.bottom+"% "+inset.left+"%";
			style.inset=st;
		}
		console.log("getStyleEvent",this.consultation,style);
		return style;
	}
	
	getStyleConsultation() {
		let isconsult:boolean=(!this.consultation.consultation);
		let color:any= this.consultation.consultation 
				?this.consultation.consultation.type.color: this.consultation.type.color;
				
		let opacity:number= this.consultation.consultation ?
		this.consultation.consultation.type.alpha
			:this.consultation.type.alpha;
		if (!isconsult)
			opacity-=opacity*25/100;
		opacity/=255;	
		let style:any={
				position:"absolute",
				background:color,
				opacity:opacity
		};     
		
		//console.log("getStyleConsultation",this.consultation,style);
		
		
      
		
	    if (this.consultation.inset!==undefined) {
			
			let inset:any=this.consultation.inset;
			let left:number=inset.left;
			if (left==0)
				left=left*(1+5/100);
			else
				left=left*(1+1/100);
			let st:string=inset.top+"% "+inset.right+"% "+ inset.bottom+"% "+left+"%";
			style.inset=st;
		}
//		console.log("getStyleConsultation",this.consultation,style);
		return style;
	}
	
	displayContextMenu(event:any,conslt:any) {

		   this.isDisplayContextMenu = !this.isDisplayContextMenu;
	       if (conslt.objectType=="visit")
			   this.rightClickMenuItems = [
			     {
			       menuText: '<i class="la la-edit"></i> Rendez-vous',
			       menuEvent: { action:'edit',
					            object:conslt
							}
			     }
			   ];
			else {
				this.rightClickMenuItems = [
				     {
				       menuText: '<i class="la la-edit"></i> Séance',
				       menuEvent: 	 { action:'edit',
					   			       object:conslt
					   				},
				     },
					 {
					 		menuText: '<i class="la la-plus"></i> Rendez-vous',
					 		menuEvent: 	{ action:'add',
										  object:conslt
										},
					  }
				]; 
			}
			this.rightClickMenuPositionX = event.pageX-event.layerX-event.offsetX;
			this.rightClickMenuPositionY = event.pageY-event.layerY-event.offsetY;
			this.rightClickMenuInset=conslt.inset;
	       console.log("displayContextMenu",event,conslt);
		 }

		 getRightClickMenuStyle() {
		   /**/
		   if (this.rightClickMenuInset) {
		   let style: any = {
		   			position: "relative",
		   			"margin-left": "5%",
					"margin-right": "5%",
					display: "block"
		   		};
		   		
		   		

		   		/*	let inset: any = this.rightClickMenuInset;
		   			let st: string = inset.top + "% " + inset.right + "% " + inset.bottom + "% " + inset.left + "%";
		   			style.inset = st;
		   		*/
		       return style; 
		   } else {
			return {
				     /*position: 'fixed',
				     left: `${this.rightClickMenuPositionX}px`,
				     top: `${this.rightClickMenuPositionY}px`
					 */
						margin: "5%",
						display: "block"
				   }
		   }
		 }

		 handleMenuItemClick(event) {
				event.event.preventDefault();
		     console.log("displayContextMenu Click",event);
			 
			 let menuEvent:any=event.data
			 
			 let conslt:any=menuEvent.object;
			 
			 let dataVs:any= {
			                 action: "create",
			                 dataType: "rdv",
			               /*  code: type,
			                 dossier: d,
			 				page: pageUrl,*/
			                 title: "Modification d'"+((conslt.objectType=="visit") ? "un rendez-vous":"une séance"),
			                 create: true,
			             };
				
				dataVs["page"]={key:"DOSSIERCONSULATION"};
				if (menuEvent.action=="add") {
					if (conslt.objectType=="visit")	 {
					} else {
						this.stateService.updateConsultation(conslt);
						dataVs["title"]="Création d'un rendez-vous";
						this.dialogService.open(VisiteActionsDialog, {
								             data: dataVs,
								             height: "95vh",
								             width: "80vw",					 
								             draggable: true,
								             resizable: true,
								             minimizable: true,
								             maximizable: true,
								         }, (res: any) => {
								                    console.log(res)
								                     
								 	               
					     })
					}
						
				} else {
					if (conslt.objectType=="visit")	 {
						this.stateService.updateConsultation(conslt.consultation);
						dataVs["visite"]=conslt;
						
						let dossier:any={};
						if (conslt.tiers!=undefined) {
							dossier.tiers=conslt.tiers;
							dossier.ID=conslt.tiers.dossierID;
						}
						dataVs["dossier"]=dossier;
				         this.dialogService.open(VisiteActionsDialog, {
				             data: dataVs,
				             height: "95vh",
				             width: "80vw",					 
				             draggable: true,
				             resizable: true,
				             minimizable: true,
				             maximizable: true,
				         }, (res: any) => {
				                    console.log(res)
				                     
				 	               
				            })
					}
					else {
						this.stateService.updateConsultation(conslt);
						
						this.dialogService.open(CreateConsultationDialogComponent, {
						           data: dataVs,
						           height: "95vh",
						           width: "80vw",
						           draggable: true,
						           maximizable: true,
						           minimizable: true,
						           resizable: true,
						       }, (res: any) => {
						       	console.log(res);
						        
						       
						   })		
					}
					
				}
			//	this.isDisplayContextMenu = !this.isDisplayContextMenu;
			/* switch (event.data) {
		     case this.rightClickMenuItems[0].menuEvent:
		          console.log('To handle refactor');
		          break;
		     case this.rightClickMenuItems[1].menuEvent:
		         console.log('To handle formatting');
		   }*/
		 }
	
	
}
